import React from "react";
import { useSelector } from "react-redux";
import SwitchLanguage from "../SwitchLanguage";
import { selectPageTitle } from "../../app/features/DataSlice";
import { Container, Navbar } from "react-bootstrap";

const TopNav = ({ setToggleMenu, toggleMenu }) => {
  const PageTitle = useSelector(selectPageTitle);
  return (
    <Navbar bg="dark1" data-bs-theme="dark">
      <Container fluid className="px-3">
        <Navbar.Brand className="d-flex flex-start text-wrap fs-6 fs-md-3">{PageTitle}</Navbar.Brand>
        <div className="d-flex">
          <button
            className="btn btn-sm me-1 px-3"
            id="sidebarToggle"
            onClick={() => setToggleMenu(!toggleMenu)}
            style={{
              padding: "10px 20px",
              borderRadius: "10px",
              backgroundColor: "#fff",
              textTransform: "uppercase",
              border: 0,
              color: "black"
            }}
          >
            <i className={`fas fa-${toggleMenu ? 'times' : 'bars'} text-dark`}></i>
          </button>
          <SwitchLanguage />
        </div>
      </Container>
    </Navbar>
  );
};

export default TopNav;
